import { useEffect, useRef, useState } from "react";

import { ParaTag } from "@tm/static";

import { theme } from "@tm/utility/global";

import {
  IconContainer,
  InputWpr,
  TMInputStyle,
  TMInputWrap,
  VerifiedContainer,
} from "./TMFloatingInput.style";

import { DownArrow } from "../../icons/DownArrow";
import { EditIcon } from "../../icons/EditIcon";
import { TMFloatingInputProps } from "./types";

const TMFloatingInput = ({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  inputValue,
  handleChange,
  verifiedTag,
  maxLength,
  onFocus,
  onBlur,
  type = "text",
  inputMode,
  flex,
  fieldType = "text",
  showEdit = false,
  handleEditClick,
  handleDropdownPress,
  defaultFocus = false,
}: TMFloatingInputProps) => {
  const [isFocus, setIsFocus] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (defaultFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [defaultFocus]);

  const inputFocusHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    if (fieldType === "select") {
      event.preventDefault();
      event.currentTarget.blur();
    }
    !(fieldType === "select") && setIsFocus(true);
    onFocus && onFocus();
  };

  const inputBlurHandler = () => {
    !(fieldType === "select") && setIsFocus(false);
    onBlur && onBlur();
  };

  const handleClick = () => {
    if (fieldType === "select" && handleDropdownPress) {
      handleDropdownPress();
    }
  };

  return (
    <TMInputWrap
      disableState={disableState}
      margin={margin}
      inputWidth={inputWidth}
      flex={flex}
      placeholder={placeholderTxt}
      clickable={fieldType === "select"}
      onClick={handleClick}
    >
      <InputWpr>
        <TMInputStyle
          ref={inputRef}
          id={labelTxt}
          isActive={isFocus}
          inputMode={inputMode}
          onChange={fieldType === "select" ? () => {} : handleChange}
          value={inputValue}
          errorState={errorState}
          onBlur={inputBlurHandler}
          verifiedTag={verifiedTag}
          disableState={disableState}
          onFocus={inputFocusHandler}
          placeholder={placeholderTxt}
          spellCheck={"false"}
          maxLength={maxLength}
          type={type}
          required
          clickable={fieldType === "select"}
        />
        {labelTxt && (
          <label
            htmlFor={fieldType === "select" ? "" : labelTxt}
            className="labelText"
          >
            {labelTxt}
          </label>
        )}
        {fieldType === "text" && verifiedTag && (
          <VerifiedContainer>
            <ParaTag fontSize="xs" fontWeight="bold" color={theme.darkGreen}>
              {verifiedTag}
            </ParaTag>
          </VerifiedContainer>
        )}
        {fieldType === "text" && showEdit && (
          <IconContainer onClick={handleEditClick}>
            <EditIcon />
          </IconContainer>
        )}

        {fieldType === "select" && (
          <IconContainer>
            <DownArrow />
          </IconContainer>
        )}
      </InputWpr>
      {errorState && (
        <ParaTag
          margin="4px 0 0"
          color={theme.redText2}
          fontSize="xs"
          dangerousText={errorState}
        />
      )}
    </TMInputWrap>
  );
};

export default TMFloatingInput;
